module.exports = __webpack_public_path__ + "img/html.bf5b59ac.svg";